var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectors({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 36,
    viewBox: "0 0 22 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36679 0.208496C5.47933 0.208496 3.66918 0.958285 2.33455 2.29292C0.999913 3.62755 0.250122 5.43771 0.250122 7.32516V14.4418C0.250122 16.3293 0.999913 18.1394 2.33455 19.4741C3.66918 20.8087 5.47933 21.5585 7.36679 21.5585H14.4835V28.6752H0.250122V35.7918H14.4835C16.3709 35.7918 18.1811 35.042 19.5157 33.7074C20.8503 32.3728 21.6001 30.5626 21.6001 28.6752V21.5585C21.6001 19.671 20.8503 17.8609 19.5157 16.5263C18.1811 15.1916 16.3709 14.4418 14.4835 14.4418H7.36679V7.32516H21.6001V0.208496H7.36679Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectors);
export default __webpack_public_path__ + "static/media/Vectors.218adb1e8d8dc1f4532b140f838db496.svg";
export { ForwardRef as ReactComponent };